import { ArrowRightOutlined, StarFilled } from '@ant-design/icons';
import { Trans } from '@lingui/macro';
import { Avatar, Col, Row, Tag, Typography } from 'antd';
import React from 'react';
import Cookies from 'universal-cookie';
import { getRootUrl } from '../../../helpers/urlSync';
import { StyledCard } from './CompanySelectCard.Style';
import { CookieKey } from '../../../enums/CookieKey';

const {Text} = Typography;

const colorPalettes = [
    '#1FB6C6',
    '#1EC9C0',
    '#4FDAB0',
    '#85E899',
];
export function CompanySelectCard({
    company,
    isFeatured,
}) {
    // const dateLoggedIn = moment().format('DD/MM/YYYY');
    const { subdomain, legal_name, id } = company;

    const onCardClick = () => {
        const cookies = new Cookies();
        const options = {};
        const urlMode = process.env.REACT_APP_URL_MODE;
        const urlDomain = process.env.REACT_APP_URL_DOMAIN;

        // console.log('aaa onCardClick', getRootUrl(subdomain));

        options.path = '/';
        if (urlMode === 'subdomain')
            options.domain = `.${urlDomain}`;
        options.expires = new Date(Date.now() + (3600 * 24 * 7 * 1000)); // 7 days
        cookies.set(CookieKey.last_logged_in_cs, subdomain, options); // company subdomain

        // window.location.href = `${getRootUrl(subdomain)}/dashboard`;
    };
    return (
        <StyledCard
            hoverable
            onClick={onCardClick}
            className={`${isFeatured ? 'featured' : ''}`}
        >
            <a href={`${getRootUrl(subdomain)}/dashboard`}>
                <Row justify="space-between" gutter={[3, 3]}>
                    <Col xs={4} sm={6} className="avatar-col">
                        <Avatar
                            size="large"
                            style={{ backgroundColor: colorPalettes[id % colorPalettes.length] }}
                        >
                            {subdomain?.substr(0, 2)}
                        </Avatar>
                    </Col>
                    <Col xs={20} sm={18}>
                        <Row>
                            <Col span={24}><Tag>{subdomain}</Tag></Col>
                            <Col span={24} className="ellipsis-div">
                                <Text className="company-name-text">{legal_name}</Text>
                            </Col>
                            <Col span={24} className={`recent-log-in-col ${!isFeatured ? 'hidden' : ''}`}>
                                <Text type="secondary">
                                    <Trans>
                                        Recently logged in
                                    </Trans>
                                </Text>
                            </Col>

                        </Row>
                    </Col>
                    <div className={`go-corner ${isFeatured ? 'featured' : ''}`} href="#">
                        {
                            isFeatured ?
                                <StarFilled className="go-icon" twoToneColor="#ffc069" /> :
                                <ArrowRightOutlined className="go-icon" />
                        }
                    </div>
                </Row>
            </a>
        </StyledCard>
    );
}
